import React, { useRef, useState } from 'react';
import './VideoShowcase.css';

const VideoShowcase = () => {
  const [currentVideo, setCurrentVideo] = useState(-1); // -1 = жодного відео не грає
  const videoRefs = useRef([]);

  const videos = [
    { id: 1, src: '/assets/video2.mp4', title: 'Collection Highlight 1', poster: 'assets/video1-thumb.jpg' }, 
    { id: 2, src: '/assets/video3.mp4', title: 'Collection Highlight 2', poster: 'assets/video2-thumb.jpg' },
    { id: 3, src: '/assets/video4.mp4', title: 'Collection Highlight 3', poster: 'assets/video3-thumb.jpg' },
    { id: 4, src: '/assets/video1.mp4', title: 'Behind the Scenes', poster: 'assets/video4-thumb.jpg' }
  ];

  const handlePlay = (index) => {
    // Зупиняємо всі інші відео
    videoRefs.current.forEach((v, i) => {
      if (v && i !== index) v.pause();
    });
    setCurrentVideo(index);
    const video = videoRefs.current[index];
    if (video) video.play();
  };

  const handlePause = (index) => {
    setCurrentVideo(-1);
  };

  return (
    <section className="video-showcase">
      <div className="video-header">
        <h2 className="video-title">Collection in Motion</h2>
        <p className="video-subtitle">Experience the runway</p>
      </div>

      <div className="video-grid">
        {videos.map((video, index) => (
          <div key={video.id} className="video-container">
            <video
              ref={el => videoRefs.current[index] = el}
              className="video-player"
              loop
              playsInline
              preload="metadata"
              controls
              poster={video.poster}
              onPlay={() => handlePlay(index)}
              onPause={() => handlePause(index)}
            >
              <source src={video.src} type="video/mp4" />
            </video>
            {/* Play-overlay тільки для неактивних */}
            {currentVideo !== index && (
              <div 
                className="video-play-overlay"
                onClick={() => handlePlay(index)}
                style={{pointerEvents: 'auto'}}
              >
                <div className="play-button">
                  <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
                    <circle cx="30" cy="30" r="29" stroke="white" strokeWidth="2" opacity="0.8"/>
                    <path d="M24 18L42 30L24 42V18Z" fill="white"/>
                  </svg>
                </div>
              </div>
            )}
            <div className="video-info">
              <span className="video-number">{String(video.id).padStart(2, '0')}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default VideoShowcase;
